<div class="deposit_withdrawal" *ngIf="iframeUrl">
    <button class="btn-back" (click)="back()">Back</button>
    <app-loader *ngIf="isLoad" class="no-overlay"></app-loader>
    <iframe scrolling="yes" [src]="iframeUrl | safeURL" allowfullscreen="true" title="game"></iframe>
</div>